import { Form, Row, Col, Button, InputGroup } from "react-bootstrap";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import Flatpickr from "react-flatpickr";
import {
  setActiveTab,
  setPaginationPageNumber,
  TriggerFilterButtonApi,
} from "../../../slices/common/reducer";
import {
  filterDateOptions,
  handleFilterDateChange,
} from "../../../Utils/CommonUtils";
import { setPspFilterForm } from "../../../slices/psp/serviceProvider/reducer";
import { PSP_FROM_DATE, PSP_TO_DATE } from "../../../Utils/FilterDateKeys";
import { CiSearch } from "react-icons/ci";
import "./ServiceProvider.scss";
import { useEffect } from "react";
import { getCategoryDropdown } from "../../../Utils/CommonService";

const ServiceProviderFilter = () => {
  const dispatch = useDispatch();

  const filterForm = useSelector((state) => state.serviceProvider.filter.form);
  const pspCategory = useSelector((state) => state.common.categoryDropdown);

  const pspDropDown = pspCategory.map((psp) => {
    return {
      value: psp,
      label: psp,
    };
  });

  // Reset tab and pagination when filters change
  const resetTabAndPageNumber = () => {
    dispatch(setPaginationPageNumber(0));
    dispatch(setActiveTab("ALL"));
  };

  // Handle input changes for text and select fields
  const handleInputChange = (name, value) => {
    dispatch(setPspFilterForm({ name, value }));
    resetTabAndPageNumber();
    dispatch(TriggerFilterButtonApi());
  };

  // Order status options
  const pspOptions = [
    { value: "ACTIVE", label: "Active" },
    { value: "INACTIVE", label: "Inactive" },
  ];

  const handleClear = () => {
    dispatch(setPspFilterForm({ type: "reset" }));

    dispatch(TriggerFilterButtonApi());

    if (Object.keys(filterForm).length > 0) {
      resetTabAndPageNumber();
    }
  };

  useEffect(() => {
    getCategoryDropdown("PSP", "psp_category");
  }, []);

  const isClearButtonDisabled = !Object.values(filterForm).some(
    (value) => value
  );

  return (
    <div className="filter-wrapper">
      <Form className="form-input">
        <Row>
          <Form.Group as={Col} className="col-md-4">
            <InputGroup>
              <InputGroup.Text id="basic-addon1">
                {" "}
                <CiSearch />
              </InputGroup.Text>
              <Form.Control
                type="text"
                placeholder="Search for Code, Name..."
                name="filter_ref"
                id="name"
                className="psp-searchbar"
                value={filterForm.filter_ref || ""}
                onChange={(e) =>
                  handleInputChange(e.target.name, e.target.value)
                } // Update on change
              />
            </InputGroup>
          </Form.Group>
          <Form.Group as={Col} className="col-md-4">
            <Select
              isClearable
              placeholder="PSP Category"
              name="buss_category"
              options={pspDropDown}
              value={
                pspDropDown.find(
                  (itm) => itm.value === filterForm.buss_category
                ) || null
              }
              onChange={(e) =>
                handleInputChange("buss_category", e ? e.value : "")
              }
            />
          </Form.Group>
          <Form.Group as={Col} className="col-md-3">
            <Select
              isClearable
              placeholder="Status"
              name="status"
              options={pspOptions}
              value={
                pspOptions.find((itm) => itm.value === filterForm.status) ||
                null
              }
              onChange={(e) => handleInputChange("status", e ? e.value : "")}
            />
          </Form.Group>
          <Form.Group as={Col} className="col-md-1">
            <div>
              <Button
                className="primary-outline"
                onClick={handleClear}
                disabled={isClearButtonDisabled}
              >
                Clear
              </Button>
            </div>
          </Form.Group>
        </Row>
      </Form>
    </div>
  );
};

export default ServiceProviderFilter;
